import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { public_routes } from "./feature-module/router/all_routes";
import axios from "./api/axios";
import { api_path } from "./environment";
import { useSelector } from "react-redux";

const SESSION_ERROR_CODES = [
  "SESSION_EXPIRED",
  "SESSION_INVALID",
  "TOKEN_EXPIRED",
  "TOKEN_INVALID",
  "ACCOUNT_DISABLED",
  "TOKEN_MISSING",
];

// Message affiché selon le code d'erreur
const ERROR_CONFIG = {
  SESSION_EXPIRED: {
    title: "Session expirée",
    message:
      "Votre session a expiré en raison d'une inactivité prolongée. Veuillez vous reconnecter.",
    iconClass: "ti ti-clock-x",
    iconColor: "#F59E0B",
    bgColor: "#FFF3CD",
  },
  ACCOUNT_DISABLED: {
    title: "Compte désactivé",
    message:
      "Votre compte a été désactivé. Veuillez contacter l'administration.",
    iconClass: "ti ti-lock",
    iconColor: "#EF4444",
    bgColor: "#FEE2E2",
  },
  default: {
    title: "Session invalide",
    message: "Votre session est invalide. Veuillez vous reconnecter.",
    iconClass: "ti ti-alert-circle",
    iconColor: "#EF4444",
    bgColor: "#FEE2E2",
  },
};

type ErrorCode = keyof typeof ERROR_CONFIG;

const SessionExpiredModalListener = () => {
  const routes = public_routes;
  const navigate = useNavigate();

  const { expired, code } = useSelector((state: any) => state.session);

  // Écoute l'état auth Redux pour savoir si on est connecté
  const isAuthenticated = useSelector((state: any) => !!state.auth.user);

  // ─── Vérification silencieuse de la session ───────────────────────────────
  const checkSession = async () => {
    try {
      if (!isAuthenticated) return;
      await axios.get(api_path + `/api/auth/getMe`);
      // OK → session toujours valide
    } catch (e) {
      // console.log(e);
    }
  };

  // ─── 1. Vérification au retour sur l'onglet (comme Edupage) ──────────────
  // Déclenché dès que l'utilisateur revient sur la page, SANS action de sa part
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkSession();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [isAuthenticated]);

  const handleReconnect = () => {
    navigate(routes.login);
  };

  const config = SESSION_ERROR_CODES.includes(code)
    ? ERROR_CONFIG[code as ErrorCode]
    : ERROR_CONFIG["default"];
  return (
    <>
      {expired && (
        <>
          <div className="session-blur-overlay" />
          <div
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.55)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "1rem",
            }}
          >
            <div
              className="card shadow-lg"
              style={{ width: "100%", maxWidth: 420, borderRadius: 16 }}
            >
              <div className="card-body text-center p-5">
                <div className="mb-4 d-flex justify-content-center">
                  <div
                    style={{
                      width: 72,
                      height: 72,
                      borderRadius: "50%",
                      backgroundColor: config.bgColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className={config.iconClass}
                      style={{ fontSize: 36, color: config.iconColor }}
                    />
                  </div>
                </div>

                <h5 className="fw-bold mb-2">{config.title}</h5>
                <p className="text-muted mb-4" style={{ lineHeight: 1.6 }}>
                  {config.message}
                </p>

                <button
                  className="btn btn-primary w-100 py-3 fw-semibold"
                  onClick={handleReconnect}
                >
                  <i className="ti ti-login me-2" />
                  Se reconnecter
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SessionExpiredModalListener;
